import React, { useEffect, useMemo, useState } from 'react'
import { ErrorCard, LoadingCard, MainContainer, NextUITable } from '../../components'
import { COLUMN_ALIGN_TYPE, COLUMN_TYPE, FOOTER_TYPE, ROW_ACTION_BTN_TYPE } from '../../components/NextUITable'
import { usePost } from '../../api/reactQueryCustomHooks'
import { apiRoute, linksUrl } from '../../constants/enum'
import { faEdit, faPlus, faTrash } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useNavigate } from 'react-router-dom'
import { Button, } from '@nextui-org/react'
import { useDispatch, useSelector } from 'react-redux'
import ConfirmBox from '../../components/ConfirmBox'
import { toast } from 'react-toastify'
import { resetDetailParams, setDetailParams, setNewEntryMode } from '../../state/journalVoucherSlice'
import { calculateTotal } from '../../Utility/utility'



const JournalVoucherEntryMaster = () => {

    const { compCode, isMultipleCompany } = useSelector((state) => state.company)
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const [itemToDelete, setItemToDelete] = useState("")
    const INITIAL_VISIBLE_COLUMNS = ["actions", "ac_name", "pac_name", "doc_no3", "amount", "vou_date"]




    const { isPending, isError,
        data = [],
        mutate: filterData } = usePost({
            url: apiRoute.transaction.journalVoucherEntry.fetchEntry,
            queryKey: "Jv Entry Data"
        })
    const exportColumns = [


        {
            name: "Credit A/C",
            uid: "ac_name",
        },
        {
            name: "Debit A/C",
            uid: "pac_name",
        },
        {
            name: "Vou.No",
            uid: "doc_no3",
        },
        {
            name: "Amount",
            uid: "amount",
        },

        {
            name: "Vou.Date",
            uid: "vou_date",
            type:COLUMN_TYPE.date
        }
    ]
    const totalAmt = useMemo(
        () =>
            calculateTotal({
                data: data,
                columnName: "amount",
            }),
        [data])


    const columns = [
        {
            name: "Actions",
            uid: "actions",
            align: COLUMN_ALIGN_TYPE.center
        },
        {
            name: "Credit A/C",
            uid: "ac_name",
            align: COLUMN_ALIGN_TYPE.center,
            sortable: true
        },
        {
            name: "Debit A/C",
            uid: "pac_name",
            align: COLUMN_ALIGN_TYPE.center,
            sortable: true
        },
        {
            name: "Vou.No",
            uid: "doc_no3",
            align: COLUMN_ALIGN_TYPE.center,
            sortable: true
        },
        {
            name: "Amount",
            uid: "amount",
            align: COLUMN_ALIGN_TYPE.center,
            sortable: true,
            footer: {
                type: FOOTER_TYPE.text,
                label: "Total: ",
                value: totalAmt,
            }
        },
        {
            name: "Vou.Date",
            uid: "vou_date",
            align: COLUMN_ALIGN_TYPE.center,
            type: COLUMN_TYPE.date,
            sortable: true,

        },
    ]



    const funLoadData = () => {
        filterData({
            data: {
                comp_code: compCode.join(","),
                vou_type: "V",
                trn_no: null
            }
        })
    }


    useEffect(() => {
        if (isMultipleCompany)
            navigate(linksUrl.dashboard.tradingDashboard)
        dispatch(resetDetailParams())
        funLoadData()
    }, [])



    let downloadDataFooter = {
        ac_name: "", pac_name: "", doc_no3: "", amount: " Total :- " + totalAmt,
        vou_date: " ",
    }
    const rowActionBtn = [
        {
            icon: <FontAwesomeIcon color="#379906" icon={faEdit} />,
            onClick: (row) => {
                let obj = {
                    comp_code: String(row.compcode),
                    trn_no: row.trn_no,
                    vou_type: row.vou_type,
                }

                dispatch(setDetailParams(obj))
                dispatch(setNewEntryMode(false))
                navigate(linksUrl.transaction.journalVoucherEntry.createJournalVoucherEntry)
            },
            type: ROW_ACTION_BTN_TYPE.link,
        },
        {
            icon: <FontAwesomeIcon color="#c40c18" icon={faTrash} />,
            onClick: (row) => {
                setItemToDelete({ trn_no: row.trn_no, comp_code: row.compcode, vou_type: row.vou_type })
            },
            type: ROW_ACTION_BTN_TYPE.link,
        },

    ]
    const onSuccessDelete = (data) => {
        setItemToDelete("")
        toast.success("Entry Deleted",
            { position: "top-center" })
        funLoadData();

    }
    const { mutate: FnDeleteEntry } = usePost({
        url: apiRoute.transaction.journalVoucherEntry.deleteEntry,
        queryKey: "DeleteJvEntry",
        onSuccessTasks: onSuccessDelete,

    })

    const handleConfirmBox = (data) => {
        if (data) {
            FnDeleteEntry({
                data: {
                    comp_code: itemToDelete.comp_code,
                    trn_no: itemToDelete.trn_no,
                    vou_type: itemToDelete.vou_type
                }
            })
        }
    }

    const handleAddNew = () => {
        dispatch(resetDetailParams())
        navigate(linksUrl.transaction.journalVoucherEntry.createJournalVoucherEntry)
    }
    if (isPending) {
        return <LoadingCard />
    }
    if (isError) {
        return <ErrorCard />
    }
    return (
        <div>
            {itemToDelete != "" ? <ConfirmBox handleConfirmBox={handleConfirmBox} /> : ""}
            <MainContainer pageName='Journal Voucher Transaction Entry' breadcrumbs={["Transaction", "J/V Transaction"]} >
                <div className="" style={{ textAlign: "right" }}>
                    <Button
                        size="sm"
                        color="primary"
                        startContent={<FontAwesomeIcon icon={faPlus} />}
                        onPress={handleAddNew}>
                        Add New
                    </Button>
                </div>

                <NextUITable
                    INITIAL_VISIBLE_COLUMNS={INITIAL_VISIBLE_COLUMNS}
                    data={data}
                    exportColumns={exportColumns}
                    columns={columns}
                    rowActionBtn={rowActionBtn}
                    downloadDataFooter={downloadDataFooter}
                    downloadFileName='JvTransaction-list'
                    showAdvanceFilter={false}
                    id="trn_no"
                >
                </NextUITable>
                
            </MainContainer>

        </div>
    )
}

export default JournalVoucherEntryMaster